// Who counts as an admin for the AI Navigator catalog tools (approve / edit /
// delete, Admin, AI Champions and Activity Log pages). Mirrors
// api/src/lib/admin.ts, which is what actually enforces it server-side.
//
// The source of truth is the "Admin" app role on the BRP-AINavigatorHub-APP
// registration, granted through the SG-AINavigator_Admins security group.
// Entra puts it in the ID token's `roles` claim, so adding or removing an
// admin is a group membership change — no code change or deploy.

export const ADMIN_ROLE = "Admin";

export function isAdmin(claims: Record<string, unknown> | undefined): boolean {
  return Array.isArray(claims?.roles) && claims.roles.includes(ADMIN_ROLE);
}

// AI Champions get the "Champion" app role through SG-AINavigator_Champions.
// It opens the AI Champions page and its Champion admin panel to them;
// admins can always see it too.
export const CHAMPION_ROLE = "Champion";

export function isChampion(claims: Record<string, unknown> | undefined): boolean {
  return Array.isArray(claims?.roles) && claims.roles.includes(CHAMPION_ROLE);
}
